import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";

import Sidenav from "../component/layout/Sidenav";
import AppPopups from "../component/Common/Popups";
import HelpBar from "../component/Common/HelpPanel/HelpBar";
import SnowflakeService from "../service/snowflake";
import { setClusterList } from "../store/actions/clusterList";

const Wrapper = () => {
  const dispatch = useDispatch();
  const clusterList = useSelector((state) => state.clusterList);
  const currentUser = useSelector((state) => state.user.currentUser);

  const Roles = useMemo(() => currentUser?.Roles || [], [currentUser]);

  useEffect(() => {
    if (
      ["SysAdmin", "BusinessAdmin", "DataManager", "DataAnalyst"].some((role) => Roles.includes(role)) &&
      !Array.isArray(clusterList)
    ) {
      const getClusterList = async () => {
        const sfService = new SnowflakeService();
        const { data, success } = await sfService.getClusterList();
        let clusterArr = [];

        if (success && data.length) {
          data.forEach((row) => {
            clusterArr.push({ value: row.name });
          });
          dispatch(setClusterList(clusterArr));
        } else dispatch(setClusterList([]));
      };
      getClusterList();
    }
  }, [Roles, clusterList, dispatch]);

  if (!currentUser || (currentUser && currentUser?.is2FARequiredToSet)) return <Outlet />;

  return (
    <Box
      sx={{
        display: "flex",
        // flexDirection: "column",
        backgroundColor: (theme) => {
          return theme.palette.TiffanyBlue.main;
        },
        overflow: "clip",
        height: "100vh",
      }}
    >
      <Sidenav />
      <Box
        sx={(theme) => ({
          minWidth: "calc(100% - 240px)",
          maxWidth: "calc(100% - 80px)",
          flexGrow: "1",
          [theme.breakpoints.down("769")]: {
            marginLeft: "0",
            maxWidth: "100%",
          },
        })}
      >
        <CssBaseline />
        <Outlet />
        <HelpBar />
      </Box>
      <AppPopups />
    </Box>
  );
};

export default Wrapper;
